import axios, { InternalAxiosRequestConfig } from "axios";
import { apiUrl } from "app/config";
import { getToken } from "helpers/TokenHelper";
import { AccessRestrictionStamp } from "entities/generated/back/AccessRestrictionStamp";
import { Audits } from "entities/generated/back/Audits";
import { BackgroundTasks } from "entities/generated/back/BackgroundTasks";
import { Categories } from "entities/generated/back/Categories";
import { Company } from "entities/generated/back/Company";
import { Documents } from "entities/generated/back/Documents";
import { Logon } from "entities/generated/back/Logon";
import { Settings } from "entities/generated/back/Settings";
import { Users } from "entities/generated/back/Users";
import { Tasks } from "entities/generated/back/Tasks";
import { UserGroups } from "entities/generated/back/UserGroups";

const defaultConfig = {
  baseURL: apiUrl,
};

// Перехватывает запросы и подставляет JWT токен.
const onRequest = async (config: InternalAxiosRequestConfig) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}

//TODO: Обработчик ошибок?
// axiosApiInstance.interceptors.response.use(onRequest)

export const axiosApiInstance = axios.create(defaultConfig);
axiosApiInstance.interceptors.request.use(onRequest);

export const apiAccessRestrictionStamp = new AccessRestrictionStamp(
  defaultConfig
);
apiAccessRestrictionStamp.instance.interceptors.request.use(onRequest)

export const apiAudits = new Audits(defaultConfig);
apiAudits.instance.interceptors.request.use(onRequest)

export const apiBackgroundTasks = new BackgroundTasks(defaultConfig);
apiBackgroundTasks.instance.interceptors.request.use(onRequest)

export const apiCategories = new Categories(defaultConfig);
apiCategories.instance.interceptors.request.use(onRequest)

export const apiCompany = new Company(defaultConfig);
apiCompany.instance.interceptors.request.use(onRequest)

export const apiDocuments = new Documents(defaultConfig);
apiDocuments.instance.interceptors.request.use(onRequest)

export const apiLogon = new Logon(defaultConfig);
apiLogon.instance.interceptors.request.use(onRequest)

export const apiSettings = new Settings(defaultConfig);
apiSettings.instance.interceptors.request.use(onRequest)

export const apiTasks = new Tasks(defaultConfig);
apiTasks.instance.interceptors.request.use(onRequest)

export const apiUserGroups = new UserGroups(defaultConfig);
apiUserGroups.instance.interceptors.request.use(onRequest)

export const apiUsers = new Users(defaultConfig);
apiUsers.instance.interceptors.request.use(onRequest)
